import { render, staticRenderFns } from "./BipolarMatrix.vue?vue&type=template&id=ab04baec&scoped=true"
import script from "./BipolarMatrix.vue?vue&type=script&lang=js"
export * from "./BipolarMatrix.vue?vue&type=script&lang=js"
import style0 from "./BipolarMatrix.vue?vue&type=style&index=0&id=ab04baec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab04baec",
  null
  
)

export default component.exports